import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2bd38f16"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "header-title"
}

import TopMenu from '@/layouts/AppLayoutHeader/TopMenu.vue'
import { useRoute } from 'vue-router'
import { computed, shallowRef } from 'vue'
import { i18n } from '@/services/i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLayoutHeader',
  props: {
  isMobileLayout: { type: Boolean, required: true },
},
  emits: ['toggle-menu'],
  setup(__props, { emit: emits }) {

const route = useRoute()
const customHeaderComponent = shallowRef<any>(null)
const customProps = shallowRef({})



const toggleMenu = () => {
  emits('toggle-menu')
}

const title = computed(() =>
  route.meta.title ? i18n.global.t(route.meta.title) : route.name
)



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["header", [
      { 'header-mobile': __props.isMobileLayout },
      { 'header-fleet': _unref(route).name === 'Fleet' },
    ]]),
    "data-test": "orcas-migration-header"
  }, [
    (customHeaderComponent.value)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(customHeaderComponent.value), {
          key: 0,
          props: customProps.value
        }, null, 8 /* PROPS */, ["props"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(title.value), 1 /* TEXT */)),
    _createVNode(TopMenu, {
      "is-mobile-layout": __props.isMobileLayout,
      onToggleMenu: toggleMenu
    }, null, 8 /* PROPS */, ["is-mobile-layout"])
  ], 2 /* CLASS */))
}
}

})